module.exports = __webpack_public_path__ + "static/media/holly-michaels.d2a543e9.jpg";